// export const firebaseConfig = {
//   apiKey: "AIzaSyDpC9EILNpHPPxIFoiVdZYySnfZxwWtN4I",
//   authDomain: "nuvest-1.firebaseapp.com",
//   databaseURL: "https://nuvest-1.firebaseio.com",
//   projectId: "nuvest-1",
//   storageBucket: "nuvest-1.appspot.com",
//   messagingSenderId: "926977302380",
// };
export const firebaseConfig = {
  apiKey: "AIzaSyBbwvVwreAXcSVl1B3OWKWQ2-Cn_WIGLCE",
  authDomain: "awesome-app-2617f.firebaseapp.com",
  databaseURL: "https://awesome-app-2617f.firebaseio.com",
  projectId: "awesome-app-2617f",
  storageBucket: "awesome-app-2617f.appspot.com",
  messagingSenderId: "334528911038",
};
